import { forwardRef, useImperativeHandle, useState } from 'react';
import { FilterContentContainer } from './styles';
import {
  FilterItem,
  Header,
  StyledCollapse,
  Wrapper,
} from '../CheckboxFilter/styles';
import newUseFilterParams from '../../../hooks/newUseFilterParams';
import { Radio, Stack, Typography } from '@mui/material';
import Icon from '../../Icon';
import {
  IFormatCheckedOptions,
  IOptionListData,
  IRadioFilterProps,
} from './types';
import { NEW_COLORS } from '../../../themes/colors/newColors';

const RadioFilter = forwardRef(
  ({ name, title, optionList }: IRadioFilterProps, ref) => {
    const [openState, setOpenState] = useState<boolean>(false);

    const { params, changeFilter } = newUseFilterParams({
      filters: {
        [name]: '',
      },
    });

    const filterParam = params[name];

    const filterOptionListCheck = optionList?.filter(
      item => String(item?.value) === String(filterParam),
    );

    const formatedList = {
      [name]: filterOptionListCheck,
    };

    const [valuesCheckedState, setValuesCheckedState] =
      useState<IFormatCheckedOptions>(formatedList);

    const generateIOptionItem = (value: any) => {
      const state = {
        value: value?.value,
        label: value?.label,
        content: value?.content,
      };

      return state;
    };

    const handleChange = (option: IOptionListData) => {
      setValuesCheckedState(prevState => {
        const currentSelection = prevState[name] || [];

        const isAlreadySelected = currentSelection.some(
          item => String(item.value) === String(option.value),
        );

        if (isAlreadySelected) {
          return {
            ...prevState,
            [name]: [],
          };
        }

        return {
          ...prevState,
          [name]: [generateIOptionItem(option)],
        };
      });
    };

    const handleSubmitFilter = () => {
      changeFilter(name, String(valuesCheckedState[name]?.[0]?.value));
    };

    useImperativeHandle(ref, () => ({
      handleSubmitFilter,
      filterValue: {
        [name]: String(valuesCheckedState[name]?.[0]?.value ?? ''),
      },
    }));

    const allSelectedRadio = valuesCheckedState[name]?.length === 0;

    return (
      <>
        <Wrapper
          bgcolor={openState ? NEW_COLORS.BASE.WHITE : NEW_COLORS.GRAYSCALE[50]}
        >
          <Header
            onClick={() => {
              setOpenState(!openState);
            }}
          >
            <Stack flexDirection="row" justifyContent="space-between">
              <Typography variant="text">{title}</Typography>
              <Icon
                name={
                  openState
                    ? 'actions-b2b-chevron-up'
                    : 'actions-b2b-chevron-down'
                }
                size={24}
              />
            </Stack>

            <Typography variant="smallText">
              {allSelectedRadio ? 'Nenhum selecionado' : 'Todos selecionados'}
            </Typography>
          </Header>

          <StyledCollapse in={openState}>
            <FilterContentContainer>
              {optionList?.map(option => (
                <FilterItem
                  onClick={() => handleChange(option)}
                  key={String(option.value)}
                >
                  <Radio
                    checked={valuesCheckedState[name]?.some(
                      item => String(item?.value) === String(option?.value),
                    )}
                  />
                  {typeof option.content === 'string' ? (
                    <Typography>{option.content}</Typography>
                  ) : (
                    option.content
                  )}
                </FilterItem>
              ))}
            </FilterContentContainer>
          </StyledCollapse>
        </Wrapper>
      </>
    );
  },
);

export default RadioFilter;
